"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsFunctionsEvaluatedListInstructions_1 = __importDefault(require("../../typeAssertions/valueIsFunctionsEvaluatedListInstructions"));
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const valueIsNumber_1 = __importDefault(require("../../typeAssertions/valueIsNumber"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const buildProgresiveUpdater_1 = __importDefault(require("../utils/buildProgresiveUpdater"));
const orderListItems_1 = __importDefault(require("../utils/orderListItems"));
const callablePushCollectionDOM = async ({ controlCallerId, entryVars: { listData: listDataEntryVar, listInstructions, listReverse, scrollInverted, isHorizontal, }, callbacks, processor, lastFunctionsOutputs, functionId, executeProcesses, extraFunctionDefinitions, store, }) => {
    if (!(0, valueIsRecord_1.default)(listDataEntryVar)
        && !(0, valueIsArray_1.default)(listDataEntryVar)
        && !(0, valueIsNullOrUndef_1.default)(listDataEntryVar)) {
        executeProcesses(functionId, callbacks.onError, 'Invalid list of data');
        // Alert.alert('Invalid list of data', `${listDataEntryVar}`)
        return;
    }
    if (!(0, valueIsFunctionsEvaluatedListInstructions_1.default)(listInstructions)) {
        executeProcesses(functionId, callbacks.onError, 'Invalid list instructions');
        // Alert.alert('Invalid list instructions', `${listInstructions}`)
        return;
    }
    const listData = (listDataEntryVar || {});
    // Transforms the data into a flat-list friendly one
    let itemContexts = [];
    let numColumns = 1;
    const { listControlId, listOptions, } = listInstructions;
    if ((0, valueIsNullOrUndef_1.default)(listControlId)) {
        executeProcesses(functionId, callbacks.onError, 'Invalid listControlId, should be a string');
        // Alert.alert('Invalid listControlId, should be a string')
        return;
    }
    const controlListUpdater = processor.root.controlListUpdatersById[listControlId];
    if (controlListUpdater) {
        controlListUpdater.cancel();
    }
    if ((listOptions === null || listOptions === void 0 ? void 0 : listOptions.numColumnsEnabled) && listOptions.numColumnsField) {
        numColumns = Number(listOptions.numColumnsField);
    }
    const orderByField = listOptions === null || listOptions === void 0 ? void 0 : listOptions.orderByField;
    if ((listOptions === null || listOptions === void 0 ? void 0 : listOptions.orderByEnabled)
        && ((0, valueIsString_1.default)(orderByField)
            || (0, valueIsNumber_1.default)(orderByField))) {
        itemContexts = (0, orderListItems_1.default)(listData, ([, recordValue]) => {
            if ((0, valueIsArray_1.default)(recordValue) || (0, valueIsRecord_1.default)(recordValue)) {
                return recordValue[orderByField];
            }
            return undefined;
        })
            .reduce((arrayAccum, [id, data]) => ([...arrayAccum, { id, data }]), []);
    }
    else {
        itemContexts = (0, orderListItems_1.default)(listData, (entry) => entry[0])
            .reduce((arrayAccum, [id, data]) => ([...arrayAccum, { id, data }]), []);
    }
    if (listReverse) {
        itemContexts = itemContexts.reverse();
    }
    processor.root.controlListUpdatersById[listControlId] = await (0, buildProgresiveUpdater_1.default)({
        store,
        controlCallerId,
        processor,
        itemContexts,
        lastFunctionsOutputs,
        listInstructions: Object.assign(Object.assign({}, listInstructions), { listControlId }),
        scrollInverted: !!scrollInverted,
        extraFunctionDefinitions,
        numColumns,
        isHorizontal: !!isHorizontal,
        onDone: () => {
            executeProcesses(undefined, callbacks.onDone);
        },
        isSwiper: false,
    });
    const newControlListUpdater = processor.root.controlListUpdatersById[listControlId];
    if (newControlListUpdater && newControlListUpdater.makeIteration) {
        newControlListUpdater.makeIteration();
    }
};
exports.default = callablePushCollectionDOM;
